import Breadcrumbs from "@/components/Breadcrumbs/Breadcrumbs";
import { Box, Divider, Grid, Typography } from "@mui/material";

const breadcrumbs = [
    {
        to: "",
        title: "Administration",
    },
    {
        title: "Dashboard",
        to: "dashboard",
    },
];

const Dashboard = () => {
    return (
        <Box>
            <Breadcrumbs trail={breadcrumbs} />

            <Divider />

            <Grid container spacing={4} p={4}>
                <Grid size={{ xs: 12, md: 12 }}>
                    <Box sx={{ display: "flex", height: 400, alignItems: "center", flexDirection: "column" }}>
                        <Box sx={{ margin: "auto" }}>
                            <Typography>Administration Panel - Dashboard</Typography>
                            <Typography>
                                This page will be extend in the future to contain various statistics and information.
                            </Typography>
                        </Box>
                    </Box>
                </Grid>
            </Grid>
        </Box>
    );
};

export default Dashboard;
